import React from 'react';
// import PropTypes from 'prop-types';
// import { required } from '../../functions/form-validaes';
import RenderSliderRedux from '../Complements/RenderSliderRedux';
import { reduxForm, Field } from 'redux-form';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { Grid, FormControl, InputLabel, Select, Typography, MenuItem, Button, Checkbox, FormControlLabel } from '@material-ui/core';
import { buttonsApp } from '../../styles/GeneralStyles';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import renderDecimalTextField from '../Complements/renderDecimalTextFiel';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
/* const creditOptions = [
    'TECNOLOGIA', 'NEGOCIO', 'ESTUDIOS', 'COMPRA VEHICULO', 'COMPRA LINEA BLANCA', 'PAGO DEUDAS'
] */
const paymentFrequency = [
    'MENSUAL'
]
const marks = [
    {
        value: 300,
        label: '$300',
    },
    {
        value: 5000,
        label: '$5,000',
    },
];
const validate = values => {
    const error = {}
    // console.log('validate', values)
    const patternAmount = new RegExp('^[0-9]+([.][0-9]{2})?$')
    if (!values.creditProposit) {
        error.creditProposit = `El campo es requerido`
    }
    if (!values.amountRequest) {
        error.amountRequest = `El campo es requerido`
    }
    if (!values.paymentFrequency) {
        error.paymentFrequency = `El campo es requerido`
    }
    if (!patternAmount.test(values.amountRequestWrite)) {
        error.amountRequestWrite = "El monto solo debe tener 2 decimales. Ejemplo: 3.22"
    }
    if (!values.paymentDay) {
        error.paymentDay = `El campo es requerido`
    }
    return error
}
const normalizeNumber = (value/* , previousValue */) => {
    if (!value) {
        return value
    }
    const onlyNums = value.replace(/[^\d]/g, '')
    return onlyNums
}

const paymentDay = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
const RequestCreditTest = props => {
    const { handleSubmit, change, valid, getBack, creditDestiny } = props
    const [alignment, setAlignment] = React.useState('left');
    const [alignmentSecond, setAlignmentSecond] = React.useState('left');
    const [state, setState] = React.useState({
        checkedA: false
    });
    const [otherTerm, setOtherTerm] = React.useState(false);
    const classes = buttonsApp()
    //console.log(creditDestiny)
    const handleAlignment = (event, newAlignment) => {
        setAlignment(newAlignment);
    };
    const handleAlignmentSecond = (event, newAlignment) => {
        setAlignmentSecond(newAlignment);
    };
    const handleChangeCheck = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };
    return (
        <div>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={3} justifyContent="center" alignItems="center">
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Field
                            data={creditDestiny}
                            labelId="demo-simple-select-filled-label"
                            id="creditProposit"
                            name="creditProposit"
                            // validate={[ required ]}
                            // onChange = { findAccountCode }
                            label={"Para que deseas tu crédito?"}
                            component={({ label, data, input, meta: { touched, error } }) => <FormControl variant="outlined" style={{ minWidth: '100%' }}>
                                <InputLabel id="demo-simple-select-outlined-label">{label}</InputLabel>
                                <Select
                                    label={label}
                                    labelId="demo-simple-select-label"
                                    // value={ creditOptions[0] }
                                    {...input} >
                                    {
                                        data.map(option => {
                                            return <MenuItem key={option.codigo} value={option.codigo}>{`${option.nombre}`}</MenuItem>
                                        })
                                    }
                                </Select>
                                {touched && error && <span style={{ color: 'red' }}>{error}</span>}
                            </FormControl>} >
                        </Field>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        {state.checkedA ?
                            <Field
                                name="amountRequest"
                                type={'text'}
                                id="amountRequest"
                                component={renderDecimalTextField}
                                //component={RenderTextFieldRedux}
                                label="Ingrese monto a solicitar"
                                fullWidth
                            /> : <Field
                                name="amountRequest"
                                id="amountRequest"
                                component={RenderSliderRedux}
                                label="Monto a solicitar"
                                values={300}
                                getAriaValueText={(v) => v}
                                aria-labelledby="discrete-slider"
                                // valueLabelDisplay="auto"
                                step={1}
                                // onChange ={ (o,v) => console.log(v)}
                                marks={marks}
                                min={300}
                                max={5000}
                                valueLabelDisplay="on"
                                handleChange={input => event => change('amountRequest', event.target.value)}
                            />}

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={state.checkedA}
                                    onChange={handleChangeCheck}
                                    name="checkedA"
                                    color="primary"
                                />
                            }
                            label="Desea ingresar el monto manualmente?"
                        />
                        {/* {state.checkedA ?
                            <Field
                                name="amountRequestWrite"
                                type={'text'}
                                id="amountRequestWrite"
                                component={renderDecimalTextField}
                                //component={RenderTextFieldRedux}
                                label="Ingrese monto a solicitar"
                                fullWidth
                            /> : ''} */}
                    </Grid>
                    {/* <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Field
                            name="higherAmount"
                            type={'number'}
                            id="higherAmount"
                            component={ RenderTextFieldRedux }
                            label="Necesitas un monto  mayor a $5,000 ?"
                            fullWidth
                            simbol='$'
                        />
                    </Grid> */}
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Typography style={{ color: '#2E2757', fontWeight: 'bold' }} >
                            {'Plazo en meses'}
                        </Typography>
                        <ToggleButtonGroup
                            value={alignment}
                            exclusive
                            onChange={handleAlignment}
                            aria-label="text alignment">
                            <ToggleButton value="left" aria-label="left aligned" onClick={() => change('term', '6') && setOtherTerm(false)}>
                                {'6 Meses'}
                            </ToggleButton>
                            <ToggleButton value="center" aria-label="centered" onClick={() => change('term', '12') && setOtherTerm(false)}>
                                {'12 Meses'}
                            </ToggleButton>
                            <ToggleButton value="right" aria-label="right aligned" onClick={() => change('term', '36') && setOtherTerm(false)}>
                                {'36 Meses'}
                            </ToggleButton>
                            <ToggleButton value="justify" aria-label="justified" onClick={() => setOtherTerm(true)/* change('term', 'other') */}>
                                {'Seleccionar otro Plazo'}
                            </ToggleButton>
                        </ToggleButtonGroup>
                        {otherTerm ?
                            <Field
                                style={{marginTop:'10px'}}
                                name="term"
                                type={'text'}
                                id="term"
                                component={RenderTextFieldRedux}
                                label="Ingrese número de plazo en meses"
                                normalize={normalizeNumber}
                                fullWidth
                            /> : ''}

                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Field
                            data={paymentFrequency}
                            labelId="demo-simple-select-filled-label"
                            id="paymentFrequency"
                            name="paymentFrequency"
                            // validate={[ required ]}
                            // onChange = { findAccountCode }
                            label={"Frecuencia de pago"}
                            component={({ label, data, input, meta: { touched, error } }) => <FormControl variant="outlined" style={{ minWidth: '100%' }}>
                                <InputLabel id="demo-simple-select-outlined-label">{label}</InputLabel>
                                <Select
                                    label={label}
                                    labelId="demo-simple-select-label"
                                    // value={ paymentFrequency[0] }
                                    {...input} >
                                    {
                                        data.map(option => {
                                            return <MenuItem key={option} value={option}>{`${option}`}</MenuItem>
                                        })
                                    }
                                </Select>
                                {touched && error && <span style={{ color: 'red' }}>{error}</span>}
                            </FormControl>} >
                        </Field>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Field
                            data={paymentDay}
                            labelId="demo-simple-select-filled-label"
                            id="paymentDay"
                            name="paymentDay"
                            // validate={[ required ]}
                            // onChange = { findAccountCode }
                            label={"Dia de pago"}
                            component={({ label, data, input, meta: { touched, error } }) => <FormControl variant="outlined" style={{ minWidth: '100%' }}>
                                <InputLabel id="demo-simple-select-outlined-label">{label}</InputLabel>
                                <Select
                                    label={label}
                                    labelId="demo-simple-select-label"
                                    // value={ paymentDay[0] }
                                    {...input} >
                                    {
                                        data.map(option => {
                                            return <MenuItem key={option} value={option}>{`${option}`}</MenuItem>
                                        })
                                    }
                                </Select>
                                {touched && error && <span style={{ color: 'red' }}>{error}</span>}
                            </FormControl>} >
                        </Field>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Typography style={{ color: '#2E2757', fontWeight: 'bold' }} >
                            {'Tipo de Cuota'}
                        </Typography>
                        <ToggleButtonGroup
                            value={alignmentSecond}
                            exclusive
                            onChange={handleAlignmentSecond}
                            aria-label="text alignment">
                            <ToggleButton value="left" aria-label="left aligned" onClick={() => change('typeFee', 'Fija')}>
                                {'Fija (Francesa)'}
                            </ToggleButton>
                            <ToggleButton value="center" aria-label="centered" onClick={() => change('typeFee', 'Alemana')}>
                                {'Variable (Alemana)'}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>
                    <Grid item xs={12} md={3} lg={3} xl={3}>
                        <Button variant="contained" type="submit"
                            fullWidth
                            style={{ height: '100%' }}
                            className={classes.buttonStandard}
                            disabled={!valid}
                        >
                            Generar
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={3} lg={3} xl={3}>
                        <Button variant="contained" onClick={getBack}
                            fullWidth
                            style={{ height: '100%' }}
                            className={classes.buttonStandard}
                        //  disabled={valid }
                        >
                            Atras
                        </Button>
                    </Grid>

                </Grid>
            </form>
        </div>
    );
};

RequestCreditTest.propTypes = {

};
const RequestCreditTestReduxForm = reduxForm(
    {
        form: 'RequestCreditTest',
        validate,
        destroyOnUnmount: false

    }
)(RequestCreditTest)

export default setPropsAsInitial(RequestCreditTestReduxForm);

// export default RequestCreditTest;